<template>
  <div class="list-questions questions">
    <div class="questions__list">
      <div v-if="listQuestions.length !== 0">
        <Question v-for="(item, index) in listQuestions"
                  :key="index"
                  :question="item"
                  :user="user" @markModerate="markModerate"
                  @deleteEntity="deleteEntity"></Question>
      </div>
      <div v-else>
        <p>Пока никто не оставил вопрос по товару.</p>
      </div>
    </div>
    <div class="questions__right-block">
      <div v-if="!formAddQuestionShow">
        <div class="questions__button-block">
          <div v-if="user.authorizedUser">
            <button class="button-red" @click="openForm">Задать вопрос о товаре</button>
          </div>
          <div v-else>
            <p class="questions__info">
              Вы сможете задать вопрос, когда <a @click="showAuth"> авторизуетесь на сайте</a>.
            </p>
          </div>
        </div>
      </div>
      <div v-else class="questions__form-wrap">
        <p class="questions__form-title">Задать вопрос о товаре</p>
        <form @submit.prevent="validationQuestion()" class="questions__form"
              :class="{'reviews__form_loaded': statusLoaded}">
          <div class="questions__form-item">
            <label for="question"></label>
            <textarea id="question"
                      v-model="formAddQuestion.question"
                      class="questions__form-input"
                      :class="{'questions__form-input_warn': v$.formAddQuestion.question.$error}"
                      placeholder="Текст вопроса"></textarea>
            <div v-for="item in v$.formAddQuestion.question.$errors" class="reviews__form-warning"
                 :class="{'reviews__form-warning_active': item}">
              {{ item.$message }}
            </div>
          </div>
          <div class="questions__form-item">
            <p class="questions__form-info">Вы задаете вопрос как:
              <span>{{
                  printUserName(user.name, user.surname)
                }}</span>
            </p>
            <AddedFile :files="formAddQuestion.files" :stateParentComponent="formAddQuestionShow" @addFiles="addFiles"
                       @deleteFile="deleteFile"></AddedFile>
            <div class="questions__form-item questions__form-switch">
              <span class="questions__form-switch-title">Отставить вопрос анонимно</span>
              <label class="switch">
                <input type="checkbox" v-model="formAddQuestion.anonymous">
                <span class="slider round"></span>
              </label>
            </div>
            <p class="reviews__form-message">Вопрос будет виден всем после проверки модератором</p>
          </div>
          <div class="button-form button-form__wrapper">
            <button :disabled="isOnSubmit" class="button-form__questions-button button-red">
              Опубликовать вопрос
            </button>
            <button class="button-form__questions-button button-red" type="button"
                    @click="closeForm">
              Закрыть
            </button>
          </div>

        </form>
      </div>
    </div>
  </div>
</template>

<script>
import Question from "@/components/Question";
import AddedFile from "@/components/AddedFile/AddedFile";
import eventBus from "@/js/eventBus";

import {useVuelidate} from '@vuelidate/core';
import {required, helpers} from '@vuelidate/validators';

// todo удалить после получения данных с сервера
import responseImg from "@/assets/images/response-avatar.png";
import reviewImg2 from "@/assets/images/review-avatar.png";
import axios from "axios";

export default {
  name      : "ListQuestions",
  props     : {
    user: {
      type   : Object,
      require: true
    },
  },
  components: {Question, AddedFile},
  data() {
    return {
      v$: useVuelidate(),
      // статические данные
      questionsLoaded    : false,
      formAddQuestionShow: false,
      isOnSubmit         : false,
      formAddQuestion    : {
        question : '',
        anonymous: false,
        files    : []
      },
      // динамические
      listQuestions: [],
      statusLoaded : false,
    }
  },
  validations: {
    formAddQuestion: {
      question: {
        required: helpers.withMessage("Заполните поле вопроса", required),
      }
    }
  },
  mounted() {
    if (this.listQuestions.length === 0) {
      this.loadQuestions(this.questionsLoaded);
    }
  },
  methods: {
    showAuth() {
      $('#f__auth').modal('show');
    },
    checkRating(n) {
      return Math.round(this.statistics.rating - n) >= 0
    },
    printUserName(name, surname) {
      let value = surname ? surname.slice(0, 1) + '.' : ''
      return `${name} ${value}`
    },
    resetFrom() {
      this.formAddQuestion = {
        question : '',
        anonymous: false,
        files    : []
      }
    },
    forumData() {
      return this.$parent.getForumData();
    },
    openForm() {
      this.formAddQuestionShow = true;
    },
    closeForm() {
      this.resetFrom();
      this.formAddQuestionShow = false;
      this.v$.formAddQuestion.$reset();
    },
    onSubmit() {
      this.isOnSubmit = true;
      const formData = new FormData();

      let forumData = this.$parent.getForumData();

      formData.append('sessid', this.user.sessid);

      formData.append('product_id', forumData.product_id);

      for (let key in this.formAddQuestion) {
        if (Array.isArray(this.formAddQuestion[key])) {
          for (let i = 0; i <= this.formAddQuestion[key].length - 1; i++) {
            formData.append(`${key}[${i}]`, this.formAddQuestion[key][i]);
          }
        } else {
          formData.append(key, this.formAddQuestion[key]);
        }
      }

      const that = this;

      that.statusLoaded = true;

      axios
          .post('/api/forum/v1/questions/', formData, {
            headers        : {
              'Content-Type': 'multipart/form-data',
            },
            withCredentials: true
          })
          .then(response => {
            that.isOnSubmit = false;
            const result = response.data;

            eventBus.$emit('info', response.data.message);

            if (result) {
              that.statusLoaded = false;
              that.resetFrom()
              that.formAddQuestionShow = false
              // обновить список вопросов
              that.loadQuestions()
            }
          });
    },
    loadQuestions(loaded = false, force = false) {
      const that = this;

      let forumData = this.$parent.getForumData();

      axios
          .get('/api/forum/v1/questions/' + forumData.product_id + '/')
          .then(response => {
            if (
                response
                && response.data
            ) {
              that.listQuestions = response.data.data.questions;
              const propOwn = Object.getOwnPropertyNames(response.data.data.questions);

              that.$emit('updateNumberQuestions', propOwn[0] === 'length' ? 0 : propOwn.length)
            }
          });
    },
    markModerate(uuid) {
      this.$emit('markModerate', uuid);
    },
    deleteEntity(uuid) {
      const formData = new FormData();
      formData.append('sessid', this.user.sessid);
      let that = this;
      axios
          .post(
              '/api/forum/v1/delete/' + uuid + '/',
              formData,
              {
                headers        : {
                  'Content-Type': 'multipart/form-data',
                },
                withCredentials: true
              }
          )
          .then(response => {
            if (
                response
                && response.data
                && response.data.result
            ) {
              that.loadQuestions();
              return true;
            }
          });
    },
    addFiles(arrayFiles) {
      this.formAddQuestion.files = arrayFiles;
    },
    deleteFile(fileName) {
      this.formAddQuestion.files.splice(this.formAddQuestion.files.indexOf(this.formAddQuestion.files.find(item => item.name === fileName)), 1);
    },
    validationQuestion() {
      this.v$.formAddQuestion.$validate();
      if (!this.v$.formAddQuestion.$error) {
        this.v$.formAddQuestion.$reset();
        this.onSubmit();
      }
    }
  }
}
</script>

<style scoped>

</style>